import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";

export default function HistoryPage() {
  const [items, setItems] = useState([]);
  const [totaux, setTotaux] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [searchesRes, logsRes] = await Promise.all([
          api.get("/searches", { params: { page: 1, page_size: 50 } }),
          api.get("/logs", { params: { page: 1, page_size: 1 } }),
        ]);
        setItems(searchesRes.data.items);
        setTotaux(logsRes.data.totaux);
      } catch (e) {
        toast.error("Erreur lors du chargement de l'historique");
      }
    })();
  }, []);

  return (
    <div className="p-6 space-y-6" data-testid="history-page">
      {totaux && (
        <div className="grid grid-cols-3 border border-border divide-x divide-border" data-testid="history-totals">
          <StatBlock label="Requetes API totales" value={totaux.total_requetes} testId="totaux-requetes" />
          <StatBlock label="Cout estime total" value={`$${Number(totaux.cout_total_usd).toFixed(3)}`} testId="totaux-cout" />
          <StatBlock label="Recherches partielles" value={totaux.nb_recherches_partielles} testId="totaux-partielles" />
        </div>
      )}
      <div className="border border-border overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="border-border">
              <TableHead className="font-mono text-xs uppercase text-muted-foreground tracking-wider">Metier</TableHead>
              <TableHead className="font-mono text-xs uppercase text-muted-foreground tracking-wider">Ville</TableHead>
              <TableHead className="font-mono text-xs uppercase text-muted-foreground tracking-wider">Rayon</TableHead>
              <TableHead className="font-mono text-xs uppercase text-muted-foreground tracking-wider">Statut</TableHead>
              <TableHead className="font-mono text-xs uppercase text-muted-foreground tracking-wider">Resultats</TableHead>
              <TableHead className="font-mono text-xs uppercase text-muted-foreground tracking-wider">Date</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.map((s) => (
              <TableRow key={s.id} className="border-border">
                <TableCell>
                  <Link to={`/recherches/${s.id}`} data-testid={`history-row-link-${s.id}`} className="text-primary hover:underline font-medium">
                    {s.metier}
                  </Link>
                </TableCell>
                <TableCell>{s.ville}</TableCell>
                <TableCell className="font-mono text-sm">{(s.rayon_m / 1000).toFixed(1)} km</TableCell>
                <TableCell className="font-mono text-xs uppercase">{s.statut}</TableCell>
                <TableCell className="font-mono text-sm">
                  {s.stats?.nb_apres_filtres} / {s.stats?.nb_apres_dedup}
                </TableCell>
                <TableCell className="font-mono text-xs text-muted-foreground">{new Date(s.created_at).toLocaleString("fr-FR")}</TableCell>
              </TableRow>
            ))}
            {items.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className="text-center py-10 text-muted-foreground font-mono text-xs uppercase" data-testid="history-empty-state">
                  Aucune recherche
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}

function StatBlock({ label, value, testId }) {
  return (
    <div className="p-4" data-testid={testId}>
      <p className="font-mono text-xs uppercase tracking-wider text-muted-foreground mb-1">{label}</p>
      <p className="font-heading text-2xl font-black tracking-tighter">{value}</p>
    </div>
  );
}
